<div class="login-page-wrapper">
  <payee-header></payee-header>
  <div class="header-divider"></div>

  <div class="login-container-wrapper">
    <div class="login-container">
      <h1 class="login-title">{{ title }}</h1>

      <form
        class="login-form"
        [formGroup]="loginForm"
        (ngSubmit)="login()"
      >
        <payee-form-field width="wide">
          <label payee-label>
            {{ "LOGIN.EMAIL_LABEL" | translate }}
          </label>
          <input
            payee-input
            formControlName="email"
            type="email"
            autocomplete="email"
            inputmode="email"
            class="form-input"
            data-testid="login-email"
          />
          @if (email.dirty) {
            <ng-container payee-error>
              @if (email.hasError("required")) {
                <mat-error>
                  {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
                </mat-error>
              }
              @if (email.hasError("email")) {
                <mat-error>
                  {{ "ERROR_MESSAGES.INVALID_EMAIL" | translate }}
                </mat-error>
              }
            </ng-container>
          }
        </payee-form-field>

        <payee-form-field width="wide">
          <div
            payee-label
            class="password-label-row"
          >
            <label>
              {{ "LOGIN.PASSWORD_LABEL" | translate }}
            </label>
            @if (forgotPasswordPath) {
              <a
                class="forgot-password-link"
                [routerLink]="forgotPasswordPath"
              >
                {{ "LOGIN.FORGOT_PASSWORD" | translate }}
              </a>
            }
          </div>
          <input
            type="password"
            payee-input
            formControlName="password"
            autocomplete="current-password"
            class="form-input"
            data-testid="login-password"
          />
          @if (password.dirty) {
            <ng-container payee-error>
              @if (password.hasError("required")) {
                <mat-error>
                  {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
                </mat-error>
              }
            </ng-container>
          }
        </payee-form-field>

        @if (showRememberMe) {
          <mat-checkbox formControlName="remember_me">
            {{ "LOGIN.REMEMBER_ME_LABEL" | translate }}
          </mat-checkbox>
        }

        <input
          type="submit"
          hidden
        />

        @if (loginForm.hasError("unknown")) {
          <mat-error class="form-error">
            {{ "LOGIN.UNKNOWN_ERROR" | translate }}
          </mat-error>
        }
        @if (loginForm.hasError("invalid_password")) {
          <mat-error class="form-error">
            {{ "LOGIN.INVALID_CREDENTIALS" | translate }}
          </mat-error>
        }

        <button
          payee-button
          type="submit"
          width="wide"
          height="tall"
          color="blue-payee"
          data-testid="login-submit"
          [disabled]="loading()"
        >
          @if (!loading()) {
            <span>{{ "LOGIN.LOGIN_BUTTON" | translate }}</span>
          }
          @if (loading()) {
            <span>{{ "LOGIN.LOADING" | translate }}</span>
          }
        </button>

        <!-- Secondary CTA -->
        @if (registerPath) {
          <a
            style="text-decoration: none; display: block"
            [routerLink]="registerPath"
          >
            <button
              type="button"
              payee-button
              width="wide"
              height="tall"
              color="white"
              [isBorderButton]="true"
            >
              {{ "LOGIN.REGISTER_CTA" | translate }}
            </button>
          </a>
        }
      </form>

      <ng-content></ng-content>

      <!-- Additional Links -->
      <div class="additional-links">
        <ng-content select="[additional-links]"></ng-content>
      </div>
    </div>
  </div>

  <app-footer-simple></app-footer-simple>
</div>
